import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { List } from '../../models/list.model';
import { Role } from 'src/app/models/role.model';
import { AvailableResources } from 'src/app/models/available-resources.model';
import { ConfigService } from 'src/app/core/services/config-service';

@Injectable()
export class RoleService {
  constructor(private http: HttpClient) {}

  configService = inject(ConfigService);

  getRolesWithPermissions(): Observable<List<Role>> {
    const url = this.configService.readConfig().baseUrlGateway + '/admin/v1/roles/permissions';
    return this.http.get<List<Role>>(url);
  }

  getRoleDetails(name: string): Observable<Role> {
    const url = this.configService.readConfig().baseUrlGateway + `/admin/v1/roles/${name}/permissions/users`;
    return this.http.get<Role>(url);
  }

  updateRole(role: Role): Observable<any> {
    const url = this.configService.readConfig().baseUrlGateway + '/admin/v1/roles';
    return this.http.put(url, role);
  }

  createRole(role: Role): Observable<any> {
    const url = this.configService.readConfig().baseUrlGateway + '/admin/v1/roles';
    return this.http.post(url, role);
  }

  deleteRole(role: Role): Observable<any> {
    const url = this.configService.readConfig().baseUrlGateway + `/admin/v1/roles/${role.name}`;
    return this.http.delete(url);
  }

  getRolesList(): Observable<Role[]> {
    const url = this.configService.readConfig().baseUrlGateway + '/admin/v1/roles/list';
    return this.http.get<Role[]>(url);
  }

  getAvailableResources(): Observable<AvailableResources> {
    const url = this.configService.readConfig().baseUrlGateway + '/admin/v1/roles/resources';
    return this.http.get<AvailableResources>(url);
  }
}
